import { useTranslation } from 'react-i18next';

/**
 * PrivacyPage - Página de Política de Privacidade
 * Equivalente a: redirect/privacy.html.erb
 *
 * Nota: a versão autoritativa desta política é a redação em português.
 * As traduções (en/es) são informativas.
 */
export default function PrivacyPage() {
  const { t } = useTranslation();
  return (
    <div className="max-w-7xl mx-auto px-4 py-5">
      <div className="flex justify-center">
        <div className="w-full lg:w-5/6">
          <h1 className="mb-4">{t('views.registration.user_data.privacy_policy', 'Política de Privacidade')}</h1>

          <div className="privacy-content" style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
            <h2>{t('views.privacy.s1_title', '1. Informações Gerais')}</h2>
            <p>
              {t('views.privacy.s1_p1', 'A presente Política de Privacidade contém informações a respeito do modo como tratamos, total ou parcialmente, de forma automatizada ou não, os dados pessoais dos usuários que acessam nosso site. Seu objetivo é esclarecer os interessados acerca dos tipos de dados que são coletados, dos motivos da coleta e da forma como o usuário poderá atualizar, gerenciar ou excluir estas informações.')}
            </p>
            <p>
              {t('views.privacy.s1_p2', 'Esta Política de Privacidade foi elaborada em conformidade com a Lei Federal n. 12.965 de 23 de abril de 2014 (Marco Civil da Internet), com a Lei Federal n. 13.709, de 14 de agosto de 2018 (Lei de Proteção de Dados Pessoais) e com o Regulamento UE n. 2016/679 de 27 de abril de 2016 (Regulamento Geral Europeu de Proteção de Dados Pessoais - RGDP).')}
            </p>
            <p>
              {t('views.privacy.s1_p3', 'Esta Política de Privacidade poderá ser atualizada em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a consultar periodicamente esta seção.')}
            </p>

            <h2>{t('views.privacy.s2_title', '2. Direitos do usuário')}</h2>
            <p>{t('views.privacy.s2_intro', 'O site se compromete a cumprir as normas previstas no RGPD, em respeito aos seguintes princípios:')}</p>
            <ul>
              <li>{t('views.privacy.s2_principle_1', 'Os dados pessoais do usuário serão processados de forma lícita, leal e transparente (licitude, lealdade e transparência);')}</li>
              <li>{t('views.privacy.s2_principle_2', 'Os dados pessoais do usuário serão coletados apenas para finalidades determinadas, explícitas e legítimas;')}</li>
              <li>{t('views.privacy.s2_principle_3', 'Os dados pessoais do usuário serão coletados de forma adequada, pertinente e limitada às necessidades do objetivo;')}</li>
              <li>{t('views.privacy.s2_principle_4', 'Os dados pessoais do usuário serão exatos e atualizados sempre que necessário;')}</li>
              <li>{t('views.privacy.s2_principle_5', 'Os dados pessoais do usuário serão conservados apenas durante o período necessário;')}</li>
              <li>{t('views.privacy.s2_principle_6', 'Os dados pessoais do usuário serão tratados de forma segura.')}</li>
            </ul>

            <p>{t('views.privacy.s2_rights_intro', 'O usuário do site possui os seguintes direitos:')}</p>
            <ul>
              <li><strong>{t('views.privacy.s2_right_1_label', 'Direito de confirmação e acesso:')}</strong> {t('views.privacy.s2_right_1_text', 'obter confirmação de que os dados pessoais são ou não objeto de tratamento;')}</li>
              <li><strong>{t('views.privacy.s2_right_2_label', 'Direito de retificação:')}</strong> {t('views.privacy.s2_right_2_text', 'obter a retificação dos dados pessoais inexatos;')}</li>
              <li><strong>{t('views.privacy.s2_right_3_label', 'Direito à eliminação dos dados:')}</strong> {t('views.privacy.s2_right_3_text', 'ter seus dados apagados do site;')}</li>
              <li><strong>{t('views.privacy.s2_right_4_label', 'Direito à limitação do tratamento:')}</strong> {t('views.privacy.s2_right_4_text', 'limitar o tratamento de seus dados pessoais;')}</li>
              <li><strong>{t('views.privacy.s2_right_5_label', 'Direito de oposição:')}</strong> {t('views.privacy.s2_right_5_text', 'se opor ao tratamento dos dados pessoais;')}</li>
              <li><strong>{t('views.privacy.s2_right_6_label', 'Direito de portabilidade:')}</strong> {t('views.privacy.s2_right_6_text', 'receber os dados pessoais em formato estruturado;')}</li>
              <li><strong>{t('views.privacy.s2_right_7_label', 'Direito de não ser submetido a decisões automatizadas.')}</strong></li>
            </ul>

            <p>
              {t('views.privacy.s2_exercise', 'O usuário poderá exercer os seus direitos por meio de comunicação escrita enviada ao e-mail:')} <a href="mailto:atendimento@laager.com.br">atendimento@laager.com.br</a>
            </p>

            <h2>{t('views.privacy.s3_title', '3. Dever de não fornecer dados de terceiros')}</h2>
            <p>
              {t('views.privacy.s3_p1', 'Durante a utilização do site, a fim de resguardar e de proteger os direitos de terceiros, o usuário do site deverá fornecer somente seus dados pessoais, e não os de terceiros.')}
            </p>

            <h2>{t('views.privacy.s4_title', '4. Informações coletadas')}</h2>
            <p>{t('views.privacy.s4_p1', 'A coleta de dados dos usuários se dará em conformidade com o disposto nesta Política de Privacidade e dependerá do consentimento do usuário.')}</p>

            <h3>{t('views.privacy.s41_title', '4.1. Tipos de dados coletados')}</h3>
            <p>{t('views.privacy.s41_intro', 'A utilização de determinadas funcionalidades do site dependerá de cadastro, sendo que os seguintes dados do usuário serão coletados e armazenados:')}</p>
            <ul>
              <li>{t('views.devise.registrations.name', 'Nome')}</li>
              <li>{t('views.privacy.s41_data_email', 'Endereço de e-mail')}</li>
              <li>{t('views.privacy.s41_data_address', 'Endereço postal')}</li>
              <li>{t('views.privacy.s41_data_phone', 'Número de telefone')}</li>
            </ul>

            <h2>{t('views.privacy.s5_title', '5. Compartilhamento de dados pessoais')}</h2>
            <p>
              {t('views.privacy.s5_p1', 'O site não compartilha dados pessoais com terceiros, exceto quando necessário para o funcionamento do serviço ou exigido por lei.')}
            </p>

            <h2>{t('views.privacy.s6_title', '6. Segurança')}</h2>
            <p>
              {t('views.privacy.s6_p1', 'O site se compromete a aplicar as medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração, comunicação ou difusão de tais dados.')}
            </p>

            <h2>{t('views.privacy.s7_title', '7. Contato')}</h2>
            <p>
              {t('views.privacy.s7_p1', 'Em caso de dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, entre em contato:')}
            </p>
            <address>
              <strong>Laager Tecnologias Sustentáveis Ltda</strong><br />
              Avenida Dóra, No. 54<br />
              Vila Alexandria<br />
              São Paulo-SP<br />
              04.635-070<br />
              <a href="mailto:atendimento@laager.com.br">atendimento@laager.com.br</a>
            </address>
          </div>
        </div>
      </div>
    </div>
  );
}
